'use strict';

var useOnKeyboardPress = require('./useOnKeyboardPress-56e2e914.js');

var useOnEscapePress = function (onEscapeKeyDown, isEnabled) {
    if (isEnabled === void 0) { isEnabled = true; }
    useOnKeyboardPress.useOnKeyboardPress(useOnKeyboardPress.SupportedKey.ESCAPE_KEY, onEscapeKeyDown, isEnabled);
};

exports.useOnEscapePress = useOnEscapePress;
//# sourceMappingURL=useOnEscapePress-ad949d3c.js.map
